import React, { Component } from 'react';

export default class VehicleCard extends Component {
    render() {
        const { licensePlate, renavam } = this.props;
        return (
            <div className="card shadow mb-5">
                <div className="card-header border-0">
                    <h3 className="mb-0">Veículo</h3>
                </div>
                <div className="card-body">
                    <ul className="list-group list-group-flush list my--3">
                        <li className="list-group-item px-0 border-0">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h5 className="mb-0">
                                        Placa
                                    </h5>
                                </div>
                                <div className="col-auto">{licensePlate}</div>
                            </div>
                        </li>
                        <li className="list-group-item px-0 border-0">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h5 className="mb-0">
                                        Renavam
                                    </h5>
                                </div>
                                <div className="col-auto">{renavam}</div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Details/Details/VehicleCard.js